import { Controller } from '@hotwired/stimulus';

const LOAD_ERROR_MESSAGE = '読み込みに失敗しました';

// 会員の多い事業者では会員数を数えるのに時間がかかるので、会員一覧を先に出し、会員数とページ送りは後から差し込む
export default class extends Controller {
  static targets = ['count'];

  static values = {
    url: String,
    // .c-count は :first-child で余白が変わるので、ページ送りまで包む要素を足さずにセレクタで受ける
    paginator: String,
  };

  #abortController;

  connect() {
    this.#load();
  }

  disconnect() {
    this.#abortController?.abort();
  }

  async #load() {
    const abortController = new AbortController();
    this.#abortController = abortController;

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/html' },
        signal: abortController.signal,
      });
      if (!response.ok) throw new Error(response.statusText);

      const template = document.createElement('template');
      template.innerHTML = await response.text();
      const slot = (name) =>
        template.content.querySelector(`[data-slot="${name}"]`);
      this.countTarget.replaceChildren(...slot('count').childNodes);
      // 集計が上限を超えると番号付きのページ送りが返らないので、前後へ進むだけのページ送りを残す
      const paginator = slot('paginator');
      if (paginator.childElementCount > 0) {
        document
          .querySelector(this.paginatorValue)
          ?.replaceChildren(...paginator.childNodes);
      }
    } catch (error) {
      if (abortController.signal.aborted) return;

      console.error(error);
      this.countTarget.textContent = LOAD_ERROR_MESSAGE;
    }
  }
}
